export const SNACKBAR_DEFAULT_DURATION_MS = 5000
export const SNACKBAR_STATIC_DURATION_MS = -1

export const messageTypes = Object.freeze({
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
})
